import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dischargeType'
})
export class DischargeTypePipe implements PipeTransform {

  transform(value: any[], args: any, arg1: any): any {

    if (value && args) {
      var filterlist = value.filter(item => item.dischargeTypeId == args)
      if (filterlist.length > 0)
        return filterlist[0].dischargeTypeName;
    }
    return "";
  }

}
